'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { VietDevilsContainer } from './container'

export const VietDevilsGallery = () => {
  const t = useTranslations()
  const images = [
    '/image/August2023/mceclip2_93.jpg',
    '/image/August2023/mceclip3_98.jpg',
    '/image/August2023/mceclip4_73.jpg',
    '/image/August2023/mceclip6_1.jpg',
    '/image/August2023/mceclip7_34.jpg',
    '/image/June2023/mceclip10_23.jpg',
  ]

  return (
    <VietDevilsContainer className='pt-0'>
      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 2,
          skipSnaps: true,
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 5000,
            stopOnInteraction: false,
          }),
        ]}
        className='w-full'
      >
        <CarouselContent>
          {images.map((image) => (
            <CarouselItem
              key={image}
              className='basis-2/3 cursor-grab will-change-transform md:basis-1/3 lg:pl-5'
            >
              <picture className='group block overflow-hidden rounded'>
                <Image
                  src={ImageHelper.getImageUrl(image, '585_663')}
                  alt={t('viet_devils_hardcode.gallery.image_alt')}
                  width={240}
                  height={255}
                  className='w-auto object-cover'
                  loading='lazy'
                  unoptimized
                />
              </picture>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </VietDevilsContainer>
  )
}
